import { render, staticRenderFns } from "./DistributionChannelsDropdown.vue?vue&type=template&id=f155f0d0"
import script from "./DistributionChannelsDropdown.vue?vue&type=script&lang=js"
export * from "./DistributionChannelsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports